/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AlertIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import MedicalAlertIcon from './MedicalAlertIcon/index'
import No from './No/index'
import NotesIcon from './NotesIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AlertIcon({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/AlertIcon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let alertTypeValueData = fromData.useDataFormat({ viewPath,
context: 'alert',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: alertTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotesIcon'}>
<NotesIcon
  viewPath={`${viewPath}/NotesIcon`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MedicalAlertIcon'}>
<MedicalAlertIcon
  viewPath={`${viewPath}/MedicalAlertIcon`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}